import React from "react";

import NavigationTabs from "views/Bots/NLP/application/Build/Tabs/Intents/application/navigation_tabs";

const FlowTabs = ({ tabValue, setQuery, t }) => (
  <NavigationTabs tabValue={tabValue} setQuery={setQuery} t={t} />
);

export default FlowTabs;
